module.exports = __webpack_public_path__ + "img/border_rectangle2.588967c0.svg";